import { useModel as _useModel, useCssVars as _useCssVars, unref as _unref, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "chat-parent-container" }
const _hoisted_2 = ["readonly", "onKeydown"]

import { nextTick, watch } from 'vue';
import { scrollToBottom } from '@/utils/scrollUtils';


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatInput',
  props: /*@__PURE__*/_mergeModels({
    isChatEnabled: { type: Boolean },
    isFocused: { type: Boolean },
    readonly: { type: Boolean },
    borderColor: {},
    iconColor: {},
    placeholderColor: {}
  }, {
    "modelValue": { required: true },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["onMessageSend", "onFocused", "onOutOfFocus"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "4cddb23e": (_ctx.placeholderColor)
}))

const inputValue = _useModel<string>(__props, "modelValue");

const props = __props;

const emit = __emit;

watch(inputValue, () => {
    resizeTextarea();
});

watch(() => props.isFocused, (isFocused) => {
    if (isFocused) {
        focus();
    } else {
        blur();
    }
});

function resizeTextarea() {
    nextTick(() => {
        const chatInput = document.getElementById('chat_input') as HTMLTextAreaElement;
        chatInput.style.height = 'auto';
        chatInput.style.height = chatInput.scrollHeight + 'px';
    });
}

function onNewLine() {
    const chatInput = document.getElementById('chat_input') as HTMLTextAreaElement;
    inputValue.value += '\n';
    scrollToBottom(chatInput);
}

function onMessageSend() {
    emit('onMessageSend');
}

function focus() {
    const chatInput = document.getElementById('chat_input') as HTMLTextAreaElement;
    chatInput.focus();
}

function blur() {
    const chatInput = document.getElementById('chat_input') as HTMLTextAreaElement;
    chatInput.blur();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "chat-icon",
      onMousedown: onMessageSend
    }, [
      (_openBlock(), _createElementBlock("svg", {
        style: _normalizeStyle({ fill: _ctx.iconColor }),
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, _cache[4] || (_cache[4] = [
        _createElementVNode("path", { d: "M33.6 15.0001C33.4 14.7001 33.1 14.4001 32.7 14.3001C32.4 14.2001 32.2 14.2001 31.9 14.3001L15.3 19.3001C15 19.4001 14.6 19.6001 14.5 20.0001C14.3 20.3001 14.2 20.7001 14.3 21.1001C14.4 21.5001 14.7 21.8001 15.1 22.0001L22.4 25.6001L26 32.9001C26.2 33.4001 26.8 33.7001 27.3 33.7001C27.5 33.7001 27.7 33.7001 27.9 33.6001C28.3 33.4001 28.6 33.1001 28.7 32.7001L33.7 16.1001C33.8 15.7001 33.8 15.3001 33.6 15.0001ZM27.3 32.1001L23.9 25.2001L28 21.0001C28.3 20.7001 28.3 20.2001 28 19.9001C27.7 19.6001 27.2 19.6001 26.9 19.9001L22.8 24.0001L15.8 20.6001L32.2 15.6001L27.3 32.1001Z" }, null, -1)
      ]), 4))
    ], 32),
    _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
      id: "chat_input",
      ref: "textarea",
      placeholder: "我想提問...",
      rows: "1",
      class: "chat-input",
      style: _normalizeStyle({ borderColor: _ctx.borderColor }),
      readonly: _ctx.readonly,
      onKeydown: [
        _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
        _withKeys(_withModifiers(onMessageSend, ["exact"]), ["enter"]),
        _withKeys(_withModifiers(onNewLine, ["shift","exact"]), ["enter"])
      ],
      onFocusin: _cache[2] || (_cache[2] = ($event: any) => (emit('onFocused'))),
      onFocusout: _cache[3] || (_cache[3] = ($event: any) => (emit('onOutOfFocus')))
    }, null, 44, _hoisted_2), [
      [_vModelText, inputValue.value]
    ])
  ]))
}
}

})